import axios from 'axios';

const API_BASE_URL = 'http://localhost:3001/api';

// Get Energy Data
export const fetchEnergyData = async () => {
  const response = await axios.get(`${API_BASE_URL}/sustainability`,{headers:{
    Authorization:`Bearer ${sessionStorage.getItem("authToken")}`
  }});
  return response.data;
};

// Update Energy Data
export const saveEnergyData = async (data) => {
  const response = await axios.post(`${API_BASE_URL}/sustainability`, { section: 'energy', data },{headers:{
    Authorization:`Bearer ${sessionStorage.getItem("authToken")}`
  }});
  return response.data;
};

// Delete Energy Data
export const resetEnergyData = async () => {
  const response = await axios.post(`${API_BASE_URL}/sustainability/energy`, { action: 'remove' },{headers:{
    Authorization:`Bearer ${sessionStorage.getItem("authToken")}`
  }});
  return response.data;
};

